<template>
  <div v-if="pdfUrl">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          :disabled="!pdfUrl"
          color="primary"
          :class="`btn-tiny ml-2 ${valorMt}`"
          fab
          v-bind="attrs"
          outlined
          v-on="on"
          @click="dialog = true"
        >
          <v-icon size="12">mdi-help</v-icon>
        </v-btn>
      </template>

      <span>Abrir documentação da ferramenta</span>
    </v-tooltip>

    <v-dialog v-model="dialog" max-width="90vw">
      <v-card height="90vh" style="overflow: hidden !important">
        <v-toolbar density="comfortable" :elevation="0" color="#3C3C3C">
          <v-spacer />

          <v-btn icon @click="dialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text class="pa-0" style="height: calc(100% - 64px)">
          <iframe :src="pdfUrl" width="100%" height="100%" style="border: none" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import VisualizarDocumentacaoService from '@/services/VisualizarDocumentacaoService';

  export default {
    props: {
      docSlugProp: {
        type: String,
        default: ''
      },
      valorMt: {
        type: String,
        default: 'mt-2'
      }
    },
    data() {
      return {
        dialog: false,
        pdfUrl: ''
      };
    },
    computed: {
      docSlug() {
        if (this.docSlugProp) {
          return this.docSlugProp;
        }

        const name = this.$route.name || '';

        return name
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '')
          .toLowerCase()
          .trim()
          .replace(/\s+/g, '-')
          .replace(/[^\w\-]+/g, '');
      }
    },
    mounted() {
      this.documentoExiste();
    },
    methods: {
      async documentoExiste() {
        this.loading = true;

        try {
          const response = await VisualizarDocumentacaoService.documentoExiste(this.docSlug);

          if (response.data) {
            await this.buscarDocumentoFerramenta();
          }
        } catch (error) {
          if (error.response.status === 404) {
            return;
          }

          this.$toast.error('Não foi possível carregar a documentação da ferramenta.', '', { position: 'topRight' });
        } finally {
          this.loading = false;
        }
      },

      async buscarDocumentoFerramenta() {
        this.loading = true;

        try {
          const response = await VisualizarDocumentacaoService.buscarDocumentoFerramenta(this.docSlug);

          const blob = new Blob([response.data], { type: 'application/pdf' });

          if (this.pdfUrl) {
            URL.revokeObjectURL(this.pdfUrl);
          }

          this.pdfUrl = URL.createObjectURL(blob);
        } catch (error) {
          if (error.response.status === 404) {
            this.pdfUrl = null;
          }

          this.$toast.error('Não foi possível carregar a documentação da ferramenta.', '', { position: 'topRight' });
        } finally {
          this.loading = false;
        }
      },

      fecharPdf() {
        this.dialog = false;

        // IMPORTANTE: liberar memória
        if (this.pdfUrl) {
          URL.revokeObjectURL(this.pdfUrl);
          this.pdfUrl = null;
        }
      }
    }
  };
</script>

<style scoped>
  .btn-tiny {
    width: 21px;
    height: 21px;
    min-width: 21px;
    padding: 0;
  }
</style>
